<template>
  <div class="dea-multiselect">
    <p class="dea-heading--regular__ms">{{ label }}</p>
    <RadioButton
      v-for="(item, index) in values"
      :id="`${group}-${item.value}`"
      :key="index"
      :name="group"
      :required="required"
      :value="item.value"
      @change="setRadioValue(item.type, $event)"
    >
      {{ item.label }}
      <input
        v-if="item.type"
        :id="`${group}-text`"
        v-model="text"
        :name="`${group}-text`"
        :type="inputTextType"
        :disabled="`${item.value}` !== value.value"
        icon
        message
        label
      />
    </RadioButton>
    <div
      :class="{
        'dea-input__icon--error dea-ico-error': currentState() === 'error',
        'dea-input__icon--success dea-ico-success': currentState() === 'success',
      }"
      class="dea-input__icon"
    ></div>
    <p
      v-if="message && currentState()"
      :class="{ 'dea-input__error-message': currentState() === 'error' }"
      class="dea-input__support-message"
    >
      {{ message }}
    </p>
  </div>
</template>

<script>
import RadioButton from "@/components/elements/RadioButton";

export default {
  name: "RadioMultiSelectMore",
  components: {
    RadioButton,
  },
  props: {
    label: {
      type: String,
      default: "",
    },
    values: {
      type: Array,
      default: () => [],
    },
    group: {
      type: String,
      default: "",
    },
    required: {
      type: Boolean,
      default: false,
    },
    validate: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: () => {
        return { text: "", value: null };
      },
    },
    inputTextType: {
      type: String,
      default: "text",
    },

    /**
     * Initial error state
     */
    state: {
      type: String,
      default: "",
    },

    /**
     * Initial error message
     */
    message: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      returnValue: {
        text: this.value.text,
        value: this.value.value,
      },
    };
  },
  computed: {
    text: {
      set(event) {
        this.returnValue.text = event;
        this.$emit("input", { target: { name: this.group, value: this.returnValue } });
      },
      get() {
        return this.value.text;
      },
    },
  },
  methods: {
    currentState() {
      if (this.state) {
        return this.state;
      }
      return !this.value.value && this.validate ? "error" : "";
    },
    setRadioValue(customText, event) {
      const result = {};
      this.returnValue.value = event.target.value;
      result.value = this.returnValue.value;
      result.text = customText ? this.returnValue.text : "";
      this.$emit("input", { target: { name: this.group, value: result } });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/system.utils";

.dea-multiselect {
  position: relative;

  .dea-checkbox:not(:first-of-type) {
    margin-left: $space-base;
  }
}

.dea-checkbox {
  display: inline-block;
  margin-left: $space-x-small;
}

.dea-heading--regular__ms {
  margin-bottom: $space-x-small;
  margin-top: $space-small;
}

.dea-input__icon {
  top: $space-x-small + 22px;
}

.dea-input__error-message {
  margin-top: -$space-x-small;
  padding-bottom: $space-small;
}
</style>
